import { render } from "./PaginationInfo.vue?vue&type=template&id=301c1990"
import script from "./PaginationInfo.vue?vue&type=script&lang=js"
export * from "./PaginationInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__